import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './alert';

export const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        showBlocked(s) {
            s.showBlocked = true;
        },
        hideBlocked(s) {
            s.showBlocked = false;
        },
    },
});
